module.exports = __webpack_public_path__ + "static/img/gl7.bfce8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/gl7.png
// module id = GFft
// module chunks = 3